import { ApiCall } from '../ApiClient';
import { ResultData } from '../ApiTypes';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export type EventInvitee = ({
    type: 'user',
    id: string,
    name: string,
    email: string,
    color: string,
    photo: string,
} | {
    type: 'email',
    email: string,
}) & {
    status: 'yes' | 'no' | 'maybe' | 'pending',
};

export type EventInviteePayload = {
    name?: string,
    email: string,
    status: string,
};

type EventCore = {
    id?: string,
    boardId: string,
    createdBy: string,
    label: string,
    description: string,
    startAt: Date,
    endAt: Date,
};

export type EventData = EventCore & {
    invites: EventInvitee[],
};

export type EventPayload = EventCore & {
    invites: EventInviteePayload[],
};

export const eventExports = {
    create: (body: EventPayload) => post<ResultData>({
        path: '/events.create',
        body,
    }),

    info: (boardId: string) => get<EventData>({
        path: '/events.info',
        query: { boardId },
    }),

    provider: () => get<ResultData>({
        path: '/events.provider',
        query: {},
    }),

    update: (body: EventPayload) => post<ResultData>({
        path: '/events.update',
        body,
    }),

    delete: (eventId: string) => post<ResultData>({
        path: '/events.delete',
        query: { eventId },
    }),
};
